<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'OPPORTUNITY_REJECTION' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="onCancel()">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <p class="info-text">{{ 'OPPORTUNITY_REJECTION_DESCRIPTION' | translate }}</p>

  <ion-item>
    <ion-textarea
      label="{{ 'REJECTION_REASON' | translate }}"
      labelPlacement="floating"
      [(ngModel)]="rejectionReason"
      [autoGrow]="true"
      placeholder="{{ 'REJECTION_REASON_PLACEHOLDER' | translate }}">
    </ion-textarea>
  </ion-item>

  <div class="button-container ion-padding-top">
    <ion-button (click)="onCancel()" color="light">{{ 'CANCEL' | translate }}</ion-button>
    <ion-button (click)="onConfirm()" color="danger" [disabled]="!rejectionReason">{{ 'CONFIRM_REJECTION' | translate }}</ion-button>
  </div>
</ion-content>